export class SelectieItem {
  constructor(init?: Partial<SelectieItem>) {
    Object.assign(this, init);
  }

  code: string;
  titel: string;
  omschrijving: string;
  icon: string;

  get filterwaarde() : string {
    if (this.titel)
      return this.omschrijving ? this.titel + " " + this.omschrijving : this.titel;

    return this.omschrijving;
  }
}